import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

const BASE_URI = `${config.apiUrl}vacations`;
class VacationsService {
  _handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.error("VacationsService Error:", error.response.data);
    } else if (error.request) {
      console.error("VacationsService Network Error:", error.message);
    } else {
      console.error("VacationsService Error:", error.message);
    }
  }

  getVacationsByYear(userId, year) {
    return axios
      .get(`${BASE_URI}/user/${userId}/year/${year}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  getVacationsBetweenDates(userId, startDate, endDate) {
    return axios
      .get(`${BASE_URI}/user/${userId}/start/${startDate}/end/${endDate}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  getVacationsYearStatistics(userId, year) {
    return axios
      .get(`${BASE_URI}/user/${userId}/year/${year}/statistics`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  getVacationsByYearList(userId, year) {
    return axios
      .get(`${BASE_URI}/user/${userId}/year/${year}/list`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  deleteVacation(id) {
    return axios
      .delete(`${BASE_URI}/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  createVacation(bodyParms) {
    return axios
      .post(`${BASE_URI}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        if (error.response && error.response.data && error.response.data.message) {
          return { error: true, message: error.response.data.message };
        }
        return null;
      });
  }

  getDepartmentVacations(year, department) {
    return axios
      .get(`${BASE_URI}/year/${year}/department/${department}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  getVacationsToApprove(year) {
    return axios
      .get(`${BASE_URI}/year/${year}/toApproved`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  getVacationsApproved(year) {
    return axios
      .get(`${BASE_URI}/year/${year}/approved`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  changeVacationStatus(bodyParms) {
    return axios
      .patch(`${BASE_URI}/status`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  rejectVacation(bodyParms) {
    return axios
      .post(`${BASE_URI}/reject`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        if (error.response && error.response.data && error.response.data.message) {
          return { error: true, message: error.response.data.message };
        }
        return null;
      });
  }

  unapproveVacation(bodyParms) {
    return axios
      .post(`${BASE_URI}/unapprove`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  exportApprovedVacationsCSV(year) {
    return axios
      .get(`${BASE_URI}/year/${year}/approved/export`, {
        headers: authHeader(),
        responseType: "blob",
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }

  thatApproves() {
    return axios
      .get(`${BASE_URI}/thatApproves`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        this._handleError(error);
        return null;
      });
  }
}
export default new VacationsService();
